import React from 'react';
import { Field } from 'formik';
import { TextField as MuiTextField } from '@mui/material';

const TextField = ({ name, label, width }) => {
  return (
    <Field name={name}>
      {({ field, form, ...props }) => (
        <MuiTextField
          variant="standard"
          style={{ width: width }}
          label={label}
          InputLabelProps={{ shrink: true }}
          error={form.touched[field.name] && Boolean(form.errors[field.name])}
          helperText={form.touched[field.name] && form.errors[field.name]}
          {...field}
          {...props}
        />
      )}
    </Field>
  );
};

export default TextField;
